"use client";

import { FaLink } from "react-icons/fa";
import { CopyToClipboardIcon } from "@/components/utils/CopyToClipboard";

export type DocumentationHeadingLinkDictionary = {
  copyLabel: string;
  copiedStatus: string;
};

function getDocumentationSectionUrl(headingId: string): string {
  const url = new URL(window.location.href);
  url.hash = headingId;
  return url.href;
}

export function DocumentationHeadingLink({
  dictionary,
  headingId,
}: {
  dictionary: DocumentationHeadingLinkDictionary;
  headingId: string;
}) {
  return (
    <CopyToClipboardIcon
      ariaLabel={dictionary.copyLabel}
      classNames="inline-flex size-[0.7em] items-center justify-center leading-none text-zinc-300 transition-colors hover:text-zinc-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-grass-400 focus-visible:ring-offset-2"
      clipboard={() => getDocumentationSectionUrl(headingId)}
      content={<FaLink aria-hidden="true" className="size-full" />}
      tooltip={dictionary.copiedStatus}
      wrapperClassNames="relative flex shrink-0"
    />
  );
}
